<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card">
                    <div class="card-header"><span id="titlista">FILTROS DA SUGESTÃO TRIMESTRAL</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div> 
                    <div class="card-body" style="padding: 10px;">
                        <div class="row" >
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edtrimestre">Trimestre: ( de {{anobase - 1}})</label>
                                <select id="edtrimestre" class="form-control form-control-sm" v-model="trimestre" data-bv-group=".group">
                                    <option value="1">Primeiro</option>
                                    <option value="2">Segundo</option>
                                    <option value="3">Terceiro</option>
                                    <option value="4">Quarto</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edano">Ano exercício:</label>
                                <select name="edano" class="form-control form-control-sm" id="edano" v-model="anobase" style="text-align: right;">
                                    <option v-for="(ano, index) in anosexercio" :key="index" :value="ano.ano">{{ ano.ano }}</option>
                                </select>
                            </div>
                        
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilial" data-placeholder="Selecione uma filial" v-model="plstfilial" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div> 

                             <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutarrelatorio()"><i class="fa fa-search"></i> Listar</button>
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <div class="dropdown" style="padding-top: 20px;">
                                    <button type="button" id="btimprimir" class="btn btn-secondary btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                        <i class="fa fa-navicon"></i> Exportar
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="mtdimprimir(false)"><i class="fa fa-print"></i> Imprimir</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdimprimir(true)"><i class="fa fa-file-excel-o"></i> Excel</a>																			
                                    </div>
                                </div>	
                            </div>      
                        </div>


                        <div class="row">
                            <div style="overflow: auto; width: 100%; margin: 40px; max-height: 40rem;">
                                <table class="table table-bordered table-striped" style="min-width: max-content;">
                                    <thead>
                                    <tr>
                                        <th v-for="coluna in colunasSugestao" :key="coluna">{{ mtdformatacabecalho(coluna) }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(linha, idx) in dadosSugestao" :key="idx">
                                            <td v-for="coluna in colunasSugestao" :key="coluna" :style="mtdalinhamento(linha[coluna])" >{{ mtdformatacoluna(linha[coluna], coluna, idx) }}</td>
                                        </tr>

                                        <tr style="font-weight: bold; background-color: #f3f3f3;">
                                            <td v-for="coluna in colunasSugestao" :key="'total-'+coluna" :style="mtdalinhamento(totalizadores[coluna])">
                                                <template v-if="coluna === 'mediacrescimento'">
                                                    {{ mtdformatavalordecimal(totalizadores[coluna], 2) + '' + '%' }}
                                                </template>

                                                <template v-else>
                                                    {{ mtdformatacoluna(totalizadores[coluna])}}
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>                                                              
                </div>
            </div>                
        </div>
    </div>        
</template>
<script>
    import { isNumeric } from 'jquery';
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import util from '../utilitarios/util.js'
    export default {
        name: 'relsugestaotrimestral',
        components:{
            'breadcrumb' : BreadCrumb,
           
        },
        data: function() {
            return { 
                utodasfiliais       : this.$store.state.usuario.todasfiliais,
                filiaisusuario      : '',

                //filtros
                plstfilial          : [],
                anosexercio         : [],
                anobase             : 1,
                trimestre           : 1,

                dadosSugestao       : [],
 
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },                
                itensbc : {
                    item1 : {
                        titulo : 'SUGESTÃO TRIMESTRAL',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                }                
            }
        },
        methods:{
            mtdformatavalordecimal(valor, digitos) {
                return util.formatavalordecimais(valor, digitos);
            },
            mtdalinhamento(coluna){
                if($.isNumeric(coluna)){
                  return 'text-align: right';
               }else{
                  return '';
               } 
            },
            mtdformatacabecalho(coluna){
                switch (coluna) {
                    case 'mediacrescimento':
                        return 'Média de Crescimento'    
                    break;
                    
                    case 'totalestoque':
                        return 'Total do estoque'    
                    break;

                    case 'previsaofaturamento':
                        return 'Previsão'    
                    break;

                    case 'sugestao':
                        return 'Sugestão'    
                    break;

                    case 'nao_informado':
                        return 'Grupo não informado'    
                    break;

                    case 'fantasia':
                        return 'Filial'    
                    break;

                    default:
                        return  coluna;
                    break;
                }
            },
            mtddefinicoesiniais(){
                let vself = this;

                let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                                

               	$("#cbfilial").select2({
                    multiple: true, // Permite múltiplas seleções
                    placeholder: 'Selecione 1 ou mais filiais',
                    allowClear: true,
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.plstfilial = $("#cbfilial").val();
				});


                let dataatual  = new Date();
                let anoatual   = dataatual.getFullYear();

                let anoinicial = anoatual + 1;

                this.anobase = anoatual;
                this.anosexercio = [];

                for (let index = 0; index <= 20; index++) {
                    let anox = {
                        'ano': anoinicial - index
                    };
                    this.anosexercio.push(anox);
                }
            }, 
            mtdexecutarrelatorio(){
                let vself = this;
                let loader = vself.$loading.show();
       
                let parametros = [
                    {parametro: 'op',           valor: 'relsugestaotrimestral'},
                    {parametro: 'idclientesac', valor: vself.$store.state.usuario.idclientesac},
                    {parametro: 'idfilial',     valor: JSON.stringify(vself.plstfilial)},  
                    {parametro: 'anoexercicio', valor: vself.anobase},
                    {parametro: 'trimestre',    valor: vself.trimestre},
                    {parametro: 'idusuario',    valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    vself.dadosSugestao   = response.data;
                   
                    loader.hide();
                
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdformatacoluna(valor, coluna = '', ind = 0) { 
                
    
                if (coluna === 'mediacrescimento' && !isNaN(parseFloat(valor))) {
                    return `${parseFloat(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}%`;
                }

                // Se for número, formata como valor normal
                if (!isNaN(parseFloat(valor))) {
                    return parseFloat(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                }

                return valor;
            },

            mtdimprimir(excel){
                let vself = this;


                let geraExel      = excel ? 1 : 0;

                let filtro        = "";
                let filial        = "";
                let selecionadas  = $('#cbfilial').select2('data');
                
                
                filial = vself.plstfilial.length == 0
                    ? 'TODAS AS FILIAIS'
                    : (selecionadas.length === 1
                        ? selecionadas[0].text
                        : selecionadas.map(item => item.text).join(', '));

                let idfil = vself.plstfilial.length > 0 ? encodeURIComponent(JSON.stringify(vself.plstfilial)) : encodeURIComponent(JSON.stringify([]))
              
                window.open(vself.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
                            vself.$store.state.filialpadrao.idcliente+
                            '&oprelatorio=20'+
                            '&filtro='+filtro+
                            '&filial='+filial+
                            '&anoexercicio='+vself.anobase+
                            '&trimestre='+vself.trimestre+
                            '&idfilial='+idfil+
                            '&excel='+geraExel+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');     
            },
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op',           valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor: vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario',    valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.filiaisusuario = response.data.filiaisusuario;
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                            position: 'bottom-end',
                            //icon: 'success',
                            title: 'Atenção!',
                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                            showConfirmButton: false,
                            showCloseButton: true,
                            backdrop: false                                                
                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }                     
                    if (util.opcaousuario('010Z.070Z', vself.$store.state.perfilusuario)) {
                        vself.mtddefinicoesiniais();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }            
        },
        computed:{
            colunasSugestao() {
                return this.dadosSugestao.length ? Object.keys(this.dadosSugestao[0]) : []
            },
            totalizadores() {
                const totais = {};

                this.colunasSugestao.forEach(coluna => {
                const valores = this.dadosSugestao
                    .map(linha => parseFloat(linha[coluna]))
                    .filter(val => !isNaN(val));

                if (coluna === 'mediacrescimento') {
                    const media = valores.length
                    ? valores.reduce((acc, val) => acc + val, 0) / valores.length
                    : 0;
                    totais[coluna] = media;
                } else {
                    const soma = valores.reduce((acc, val) => acc + val, 0);
                    totais[coluna] = valores.length ? soma : '';
                }
                });

                return totais;
            }
        },
        watch:{           
        }
    }
</script>
<style>

</style>